import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteAEnquiry,
  getEnquiries,
  resetState,
  updateAEnquiry,
  markEnquiryAsRead,
} from "../features/enquiry/enquirySlice";
import { AiFillDelete, AiOutlineEye } from "react-icons/ai";
import { Link } from "react-router-dom";
import CustomModal from "../components/CustomModal";

const Enquiries = () => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [enqId, setEnqId] = useState("");

  useEffect(() => {
    dispatch(resetState());
    dispatch(getEnquiries());
  }, [dispatch]);

  const showModal = (id) => {
    setOpen(true);
    setEnqId(id);
  };

  const hideModal = () => {
    setOpen(false);
  };

  const handleReadEnquiryClick = (enquiryId) => {
    dispatch(markEnquiryAsRead({ id: enquiryId }));
  };

  const enqState = useSelector((state) => state.enquiry.enquiries);

  const generateData = (enquiries) =>
    enquiries.map((enquiry, index) => ({
      key: index + 1,
      name: enquiry.name,
      email: enquiry.email,
      mobile: enquiry.mobile,
      status: (
        <select
          defaultValue={enquiry.status || "Submitted"}
          className="form-control form-select"
          onChange={(e) => setEnquiryStatus(e.target.value, enquiry._id)}
        >
          <option value="Submitted">Submitted</option>
          <option value="Contacted">Contacted</option>
          <option value="In Progress">In Progress</option>
          <option value="Resolved">Resolved</option>
        </select>
      ),
      action: (
        <>
          <Link
            className={`ms-3 fs-3 ${enquiry.read ? "text-secondary" : "text-primary"}`}
            to={`/admin/enquiries/${enquiry._id}`}
            onClick={() => handleReadEnquiryClick(enquiry._id)}
          >
            <AiOutlineEye />
          </Link>
          <button
            className="ms-3 fs-3 text-danger bg-transparent border-0"
            onClick={() => showModal(enquiry._id)}
          >
            <AiFillDelete />
          </button>
        </>
      ),
      className: enquiry.read ? "read-row" : "unviewed-row", // Apply class based on read/unread
    }));

  const setEnquiryStatus = (status, id) => {
    const data = { id, enqData: status };
    dispatch(updateAEnquiry(data));
  };

  const deleteEnq = (id) => {
    dispatch(deleteAEnquiry(id));
    setOpen(false);
    setTimeout(() => {
      dispatch(getEnquiries());
    }, 100);
  };

  return (
    <div>
      <h3 className="mb-4 title">Enquiries</h3>

      <Table
        columns={[
          { title: "SNo", dataIndex: "key" },
          { title: "Name", dataIndex: "name" },
          { title: "Email", dataIndex: "email" },
          { title: "Mobile", dataIndex: "mobile" },
          { title: "Status", dataIndex: "status" },
          { title: "Action", dataIndex: "action" },
        ]}
        dataSource={generateData(enqState)} // Use all enquiries in a single table
        rowClassName={(record) => record.className} // Apply class based on read/unread
      />

      <CustomModal
        hideModal={hideModal}
        open={open}
        performAction={() => deleteEnq(enqId)}
        title="Are you sure you want to delete this enquiry?"
      />
    </div>
  );
};

export default Enquiries;
